import PostProfileCTA from 'components/Directories/CTAs/PostProfileCTA'
import ListingCardWithSkeleton from './ListingCardWithSkeleton'

const Listings = ({
  listings,
  postProfileCtaText,
  postProfileCtaButtonLink,
  postProfileCtaButtonText,
  hasListing,
  isLoading,
}) => {
  const firstFiveListings = listings && listings.slice(0, 5)
  const firstFiveListingCards =
    firstFiveListings &&
    firstFiveListings.length > 0 &&
    firstFiveListings.map((listing, index) => (
      <ListingCardWithSkeleton isLoading={isLoading} listing={listing} key={index} />
    ))
  const allButFirstFive = listings && listings.slice(5)
  const allButFirstFiveListingCards =
    allButFirstFive &&
    allButFirstFive.length > 0 &&
    allButFirstFive.map((listing, index) => (
      <ListingCardWithSkeleton isLoading={isLoading} listing={listing} key={index} />
    ))

  return (
    <>
      {firstFiveListingCards}
      <PostProfileCTA
        postProfileCtaText={postProfileCtaText}
        postProfileCtaButtonLink={postProfileCtaButtonLink}
        postProfileCtaButtonText={postProfileCtaButtonText}
        hasListing={hasListing}
        isLoading={isLoading}
      />
      {allButFirstFiveListingCards}
    </>
  )
}

export default Listings
